// extracted by mini-css-extract-plugin
export default {"stepperContainer":"styles_stepperContainer__v3EF5","stepItem":"styles_stepItem__rvlmG","activeStep":"styles_activeStep__1jrX7","stepNumber":"styles_stepNumber__nPNNH"};